/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sidebar__info--flight-info[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-top:2rem;margin-bottom:2rem}  .sidebar__info--flight-info--options li>button{padding:.7rem 3rem}.top-gap[_ngcontent-%COMP%]{margin-top:1rem;margin-bottom:2rem}@media (max-width:599px){  .sidebar__info--flight-info--options li>button{padding:.7rem}.top-gap[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:block}.top-gap[_ngcontent-%COMP%]   .left-gap[_ngcontent-%COMP%]{margin-left:0}}"];
export { styles as styles };
